import React from "react";
import ReactDOM from "react-dom/client";
import "./index.css";
import reportWebVitals from "./reportWebVitals";
import {BrowserRouter, Navigate, Route, Routes} from "react-router-dom";
import FormPage from "./pages/FormPage";
import GuestLayout from "./components/GuestLayout";
import Homepage from "./pages/Homepage";
import FormGroupPage from "./pages/FormGroupPage";
import {FormSummaryPage} from "./pages/FormSummaryPage";
import {FormSinglePage} from "./pages/FormSinglePage";
import {ScannerPage} from "./pages/ScannerPage";
import {RegistrationSuccessPage} from "./pages/RegistrationSuccessPage";
import {UserLoginPage} from "./pages/UserLoginPage";
import {AdminListRegistrationsPage} from "./pages/admin/AdminListRegistrationsPage";
import {OrganizationsListPage} from "./pages/admin/AdminListOrganizationsPage";
import {AuthenticatedLayout} from "./components/AuthenticatedLayout";
import {AuthProvider} from "./components/AuthContext";
import {AdminEvent} from "./pages/admin/AdminEvent";
import {AdminNews} from "./pages/admin/AdminNews";
import {ContactsPage} from "./pages/ContactsPage";
import {SchedulePage} from "./pages/SchedulePage";
import {RoutesPage} from "./pages/RoutesPage";
import {OrganizationalInformationPage} from "./pages/InformationPage";
import {NewsPage} from "./pages/NewsPage";
import {AttractionsLinksPage} from "./pages/AttractionsLinksPage";
import {AttractionsPage} from "./pages/AttractionsPage";
import {ToursProgramPage} from "./pages/ToursProgramPage";
import {TOMProgramPage} from "./pages/TOMProgramPage";
import {AccompaniedProgramPage} from "./pages/AccompaniedProgramPage";
import {DownloadsPage} from "./pages/DownloadsPage";
import {QueryClient, QueryClientProvider} from "@tanstack/react-query";
import {
    cycleRoutesData,
    pedestrianCircuitsData,
    pedestrianOneWayRoutesData,
    pedestrianRoutesForFamiliesData,
} from "./configs";

const root = ReactDOM.createRoot(
    document.getElementById("root") as HTMLElement
);

// Create a client
const queryClient = new QueryClient();

root.render(
    <React.StrictMode>
        <AuthProvider>
            <BrowserRouter>
                <QueryClientProvider client={queryClient}>
                    <Routes>
                        <Route element={<GuestLayout/>}>
                            <Route path="/" element={<Navigate to="/homepage"/>}/>
                            <Route path="/homepage" element={<Homepage/>}/>
                            <Route path="/formpage" element={<FormPage/>}/>
                            <Route path="/form-single" element={<FormSinglePage/>}/>
                            <Route path="/form-group" element={<FormGroupPage/>}/>
                            <Route path="/form-summary" element={<FormSummaryPage/>}/>
                            <Route path="/success" element={<RegistrationSuccessPage/>}/>
                            <Route path="/login" element={<UserLoginPage/>}/>
                            <Route path="/schedule" element={<SchedulePage/>}/>
                            <Route path="/tours-program" element={<ToursProgramPage/>}/>
                            <Route path="/TOM-program" element={<TOMProgramPage/>}/>
                            <Route path="/accompanied-program" element={<AccompaniedProgramPage/>}/>
                            <Route path="/pedestrian-families-with-children" element={<RoutesPage data={pedestrianRoutesForFamiliesData}/>}/>
                            <Route path="/pedestrian-circuits" element={<RoutesPage data={pedestrianCircuitsData}/>}/>
                            <Route path="/pedestrian-one-way-routes" element={<RoutesPage data={pedestrianOneWayRoutesData}/>}/>
                            <Route path="/cycle-routes" element={<RoutesPage data={cycleRoutesData}/>}/>
                            <Route path="/latest-news" element={<NewsPage/>}/>
                            <Route path="/information" element={<OrganizationalInformationPage/>}/>
                            <Route path="/attractions-links" element={<AttractionsLinksPage/>}/>
                            <Route path="/attractions" element={<AttractionsPage/>}/>
                            <Route path="/downloads" element={<DownloadsPage/>}/>
                            <Route path="/contacts" element={<ContactsPage/>}/>
                        </Route>

                        <Route element={<AuthenticatedLayout/>}>
                            <Route path="/scanner" element={<ScannerPage/>}/>
                            <Route path="/participants" element={<AdminListRegistrationsPage/>}/>
                            <Route path="/organizations" element={<OrganizationsListPage/>}/>
                            <Route path="/event-configuration" element={<AdminEvent/>}/>
                            <Route path="/news-configuration" element={<AdminNews/>}/>
                        </Route>
                    </Routes>
                </QueryClientProvider>
            </BrowserRouter>
        </AuthProvider>
    </React.StrictMode>
);
reportWebVitals();
